import { baseApi } from '@/lib/api/baseApi';

import type {
  ExecutionDetailsResponse,
  UserDetailsResponse,
  DynamicObj,
} from './types';
import type { Builder } from '../commonApiType/apiBuilderTypes';

export const ExecutionDetailsApi = baseApi.injectEndpoints({
  endpoints: (builder: Builder) => ({
    getExecutionDetails: builder.query<ExecutionDetailsResponse, void>({
      query: () => ({
        url: '/dashboardexecution/optimize/v1/dashboard/execution/onGoingExecutionDetails',
      }),
    }),
    getUserDetails: builder.query<UserDetailsResponse, { userId: string }>({
      query: ({ userId }) => ({
        url: `/appmanagement/optimize/v1/user/${userId}`,
      }),
    }),
    terminateExecution: builder.mutation<
      DynamicObj,
      {
        executionId: string;
        executionType: string;
        treeType: string;
      }
    >({
      query: ({ executionId, executionType, treeType }) => ({
        url: `/dashboardexecution/optimize/v3/executions/status/${executionId}?status=Terminated`,
        method: 'PUT',
        params: {
          startFrom: executionId,
          executionType,
          treeType,
        },
      }),
    }),
  }),
});
